module.exports = __webpack_public_path__ + "static/img/kg.18de4fe1.svg";